const CookieUtils = {
  get: (cookieName: string): string | undefined =>
    // @ts-ignore
    Cookies.get(cookieName)
  ,
  prettyPrint: (cookieName: string): void => {
    const cookieValue = CookieUtils.get(cookieName)
    const decodedValue = JSON.parse(cookieValue || '')
    // eslint-disable-next-line no-console
    console.log(JSON.stringify(decodedValue, null, 2))
  }
}

export default CookieUtils
